import { inject } from "vue";
import { COMPANY_INFO_KEY, EXCEL_EXPORT_OPTIONS_KEY, PRODUCT_CODE_INFO_KEY, } from "../plugins/erp-info";
/**
 * @description ERP 정보 조회 컴포저블 (ERPInfoPlugin이 설치되어 있어야 함)
 * @returns {CompanyInfo, CodeInfo} ERP 정보
 */
export const useERP = () => {
    const companyInfo = inject(COMPANY_INFO_KEY);
    const codeInfo = inject(PRODUCT_CODE_INFO_KEY);
    const excelExportOptions = inject(EXCEL_EXPORT_OPTIONS_KEY);
    // null 체크 및 에러 처리
    if (!companyInfo || !codeInfo || !excelExportOptions) {
        throw new Error("ERP 정보가 초기화되지 않았습니다. ERPInfoPlugin이 설치되었는지 확인하세요.");
    }
    return {
        companyInfo,
        codeInfo,
        excelExportOptions,
    };
};
